import { useState } from 'react';
import { DepartmentsSelectRequireList } from '../ImplementData/components/Filter/DepartmentSelect';
import {
  useStoreInfoSelect,
  useStoreTypeSelect,
} from '../ImplementData/components/Filter/Provider';
import { FilterStoreInfo } from '../ImplementData/components/Filter/useFilter';
import useRegionList from 'components/StoreSelector/hooks/useRegionList';
import { StoreInfo } from 'services/api/dashboard';

function useStoreFilter({
  platform,
  departments,
  initStoreInfo,
}: {
  platform: General.PlatformUpperCase;
  departments: Dashboard.Department[];
  initStoreInfo?: StoreInfo;
}) {
  const [selectedDepartments, setSelectedDepartments] = useState<Dashboard.Department[]>([]);

  const [storeInfo, setStoreInfo] = useState<FilterStoreInfo>(
    initStoreInfo
      ? {
          list: [initStoreInfo],
        }
      : {},
  );

  const departmentsSelect = (
    <DepartmentsSelectRequireList
      dashboardType="store_performance"
      list={departments}
      value={selectedDepartments}
      onChange={(departments) => {
        setSelectedDepartments(departments);
        setStoreInfo({});
      }}
    />
  );

  const [storeType, setStoreType] = useState<Dashboard.ReceptionScore.StoreType>();

  const { storeTypeSelect } = useStoreTypeSelect({
    value: storeType,
    onChange: setStoreType,
  });

  const regionInfo = useRegionList({
    scene: 'VIEW_PLATFORM_DATA',
    departmentIds: (selectedDepartments.length ? selectedDepartments : departments).map(
      ({ id }) => id,
    ),
  });

  const { storeInfoSelect } = useStoreInfoSelect({
    regionInfo,
    platform,
    departments: selectedDepartments.length ? selectedDepartments : departments,
    platformOptions: [],
    storeType,
    storeInfo,
    onChange: setStoreInfo,
    scene: 'VIEW_PLATFORM_DATA',
  });

  return {
    selectedDepartments,
    departmentsSelect,
    setSelectedDepartments,
    storeType,
    storeTypeSelect,
    setStoreType,
    storeInfo,
    storeInfoSelect,
    setStoreInfo,
  };
}

export default useStoreFilter;
